import reportsConfig from '~/constants/data-reports/rare-earths'

export default {
  hero: reportsConfig.hero,
  descriptions: [
    'Understanding the specialist nature of rare earth elements, especially those destined for the Rare Earths Permanent Magnet (REPM) industry, is crucial to our data collection process. Our analysts are in constant contact with the major actors in the REPM supply chain.',
  ],
  descriptionImage:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto/v1719531402/assets/Rare_Earth_Separation_Plant_i9thkm.png',
  services: [
    {
      icon: 'services/icon-chart-line',
      description:
        'Create your own custom pricing charts using our bespoke data.',
    },
    {
      icon: 'services/icon-presentation',
      description:
        'Produce custom made representations of data to download for projects and presentations.',
    },
    {
      icon: 'services/icon-consultancy',
      description:
        'Access Benchmark’s exclusive industry commentary collected through our extensive network of industry contacts.',
    },
    {
      icon: 'services/icon-idea',
      description:
        'Our goal is to help you understand the context of our data, not just give you the numbers.',
    },
  ],
  logo: 'lithium-logo',
  videoId: null,
  videoProvider: null,
  indexTab: true,
  requiredFilters: ['categories', 'purities', 'shippingRoutes', 'priceTypes'],
  brochureFile: {
    file_name: 'Benchmark-Rare-Earths-Price-Assessment-Methodology.pdf',
    category: 'methodology-price-assessments',
    EnvKey: 'rareEarthsPriceAssessmentsMethodologyId',
  },
}
